import { HTTPClient } from '../utils/request'

export default {
  post: ({ payload }) => HTTPClient.post(`/ocr`, payload),
}
